export default "__VITE_ASSET__CY69IpoO__"